module.exports = __webpack_public_path__ + "static/media/gold_medal.92b14100.png";